import constants, { ACCESS_TOKEN, default_size, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";
import axiosCodeSync from "../../codeSync";
function _constructHeader(projectId) {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Authorization': 'Bearer ' + jwtToken
    }
    if (projectId) {
        headers['project-id'] = projectId;
    }
    return headers;
}

function createProject(data) {
    return axiosClient({
        url: constants.api.appBuilder.createProject,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })

}

function xrayProjectCreate(data) {
    return axiosClient({
        url: constants.api.appBuilder.xrayProject,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function getProjectById(id) {
    return axiosClient({
        url: constants.api.appBuilder.getProjectById + "/" + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

function getProject(pageNumber, data, size=default_size) {   
    return axiosClient({
        url: constants.api.appBuilder.getProject + "?page=" + pageNumber + "&size=" + size,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data !== undefined ? data : {}
    })
}

function updateProject(id, data) {
    return axiosClient({
        url: constants.api.appBuilder.updateProject + id,
        method: HTTP_METHODS.PUT,
        headers: _constructHeader(),
        data: data
    })
}

function shareProject(data) {
    return axiosClient({
        url: constants.api.appBuilder.shareProject,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function projectMembers(projectId) {
    return axiosClient({
        url: constants.api.appBuilder.projectMembers + "/" + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

function revokeProjectMember(projectId, userId) {
    return axiosClient({
        url: constants.api.appBuilder.revokeProjectMember + "/" + projectId + "/" + userId,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ""
    })
}

function checkProjectAccess(projectId) {
    return axiosClient({
        url: constants.api.appBuilder.checkProjectAccess + "/" + projectId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}
function syncCode(data, userId, settingsTab = "frontend") {
    return axiosCodeSync({
        url: constants.codeSync.syncCode.codesync_endpoint + "/" + userId + "?develop_mode=" + settingsTab,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(data?.projectId),
        data: data
    })
}

function uploadImage(projectId, data, userId) {
    let jwtToken  = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Authorization': 'Bearer ' + jwtToken,
        'project-id': projectId
    }
    const userSegment = userId ? `/${userId}` : "";
    return axiosCodeSync({
        url: constants.codeSync.syncCode.imageUpload + "/" + projectId + userSegment,
        method: HTTP_METHODS.POST,
        headers: headers,
        data: data
    })
}

function generateOAuth(provider,name, redirectUri, additionalParams = []){
    const redirectUrl = encodeURIComponent(redirectUri);
    return axiosClient({
        url: constants.api.oAuth.getOAuth + provider + "?name=" + name + "&redirectUrl=" + redirectUrl,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: additionalParams
    })
}

function genrateNonOauth(provider, configuration){
    return axiosClient({
        url: constants.api.oAuth.getManualOAuth + provider?.toUpperCase(),
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: configuration
    })
}

function getConnectedAppsListByUser(page){
    return axiosClient({
        url: constants.api.oAuth.getConnectedAppsListByUser + "?page=" + page + "&size=" + default_size,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

function getConnectedApps(provider){
    return axiosClient({
        url: constants.api.oAuth.getConnectedApps + provider,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}
function deleteOAuth(id){
    return axiosClient({
        url: constants.api.oAuth.deleteOAuth + id,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ""
    })
}

function getConnectedAppById(id) {
    return axiosClient({
        url: constants.api.oAuth.getConnectedAppById + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

function updateOAuth(provider, id, configuration) {
    const providerKey = String(provider || '').toUpperCase();
    return axiosClient({
        url: `${constants.api.oAuth.getManualOAuth}${providerKey}/${id}`,
        method: HTTP_METHODS.PUT,
        headers: _constructHeader(),
        data: configuration
    })
}
    
function compressSource(projectId) {
    return axiosClient({
        url: `${constants.api.source.compress}?projectId=${projectId}`,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: {}
    });
}

const AgentService = {
    createProject, xrayProjectCreate, getProject, updateProject, syncCode, uploadImage, generateOAuth, getConnectedAppsListByUser, getConnectedApps, getConnectedAppById, deleteOAuth, updateOAuth, genrateNonOauth,
    checkProjectAccess, projectMembers, revokeProjectMember, shareProject, getProjectById, compressSource
}

export default AgentService;